module.exports = __webpack_public_path__ + "static/media/co.9e4d6e49.svg";